import { normalizeText, convertNotionalToBRL } from './convertNotionalToBRL.js'

export function isConverted(row) {
  return normalizeText(row.status) === 'DEAL'
}

// Sum of BRL notional for converted rows only (DEAL).
// effectiveSpotByRow must come from createEffectiveSpotMap(allRows).
export function calculateConvertedVolumeBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    if (!isConverted(row)) return total

    const amount = convertNotionalToBRL(row, effectiveSpotByRow.get(row))

    if (amount == null) return total

    return total + amount
  }, 0)
}
